(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["oluna-bundle-customizer"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  if (
    window.OlunaBundleCustomizerV7
  ) {
    window
      .OlunaBundleCustomizerV7
      .init(document);

    return;
  }

  var instances =
    new Map();

  function createCustomizer(
    root
  ) {
    var sectionId =
      root.dataset.sectionId;

    var section =
      root.closest(
        'product-info'
      ) ||
      root.closest(
        '.shopify-section'
      ) ||
      root.parentElement;

    var data;

    try {
      data =
        JSON.parse(
          root.querySelector(
            '[data-oluna-bundle-data]'
          ).textContent
        );
    } catch (error) {
      console.error(
        'OLUNA : données du coffret illisibles.',
        error
      );

      return null;
    }

    var variants =
      Array.isArray(
        data.variants
      )
        ? data.variants
        : [];

    var optionNames =
      Array.isArray(
        data.optionNames
      )
        ? data.optionNames
        : [];

    function normalize(
      value
    ) {
      return String(
        value || ''
      )
        .normalize('NFD')
        .replace(
          /[\u0300-\u036f]/g,
          ''
        )
        .toLowerCase()
        .trim();
    }

    var finishIndex =
      optionNames.findIndex(
        function (name) {
          var value =
            normalize(name);

          return (
            value.includes(
              'finition'
            ) ||
            value.includes(
              'couleur'
            ) ||
            value.includes(
              'color'
            )
          );
        }
      );

    var scentIndex =
      optionNames.findIndex(
        function (name) {
          var value =
            normalize(name);

          return (
            value.includes(
              'senteur'
            ) ||
            value.includes(
              'parfum'
            ) ||
            value.includes(
              'scent'
            )
          );
        }
      );

    if (
      !section ||
      !variants.length ||
      finishIndex < 0 ||
      scentIndex < 0
    ) {
      return null;
    }

    var finishValues = [];
    var scentValues = [];

    variants.forEach(
      function (variant) {
        var finish =
          variant.options &&
          variant.options[
            finishIndex
          ];

        var scent =
          variant.options &&
          variant.options[
            scentIndex
          ];

        if (
          finish &&
          finishValues.indexOf(
            finish
          ) === -1
        ) {
          finishValues.push(
            finish
          );
        }

        if (
          scent &&
          scentValues.indexOf(
            scent
          ) === -1
        ) {
          scentValues.push(
            scent
          );
        }
      }
    );

    if (
      !finishValues.length ||
      !scentValues.length
    ) {
      return null;
    }

    var itemsNode =
      root.querySelector(
        '[data-oluna-bundle-items]'
      );

    var titleNode =
      root.querySelector(
        '[data-oluna-bundle-title]'
      );

    var introNode =
      root.querySelector(
        '[data-oluna-bundle-intro]'
      );

    var errorNode =
      root.querySelector(
        '[data-oluna-bundle-error]'
      );

    var nav =
      root.querySelector(
        '[data-oluna-bundle-nav]'
      );

    var previous =
      root.querySelector(
        '[data-oluna-bundle-prev]'
      );

    var next =
      root.querySelector(
        '[data-oluna-bundle-next]'
      );

    var current =
      root.querySelector(
        '[data-oluna-bundle-current]'
      );

    var heading =
      document.getElementById(
        'OlunaCoffretHeading-' +
        sectionId
      );

    var states = [];

    var activeIndex = 0;
    var lastQuantity = 0;

    var renderTimer =
      null;

    var retryTimer =
      null;

    var retries = 0;

    var destroyed = false;

    var observer = null;

    var priceRefreshTimers =
      [];

    /*
     * ===========================================
     * FORMULAIRE
     * ===========================================
     */

    function getProductForm() {
      var form =
        document.getElementById(
          root.dataset.productFormId
        );

      return (
        form &&
        section.contains(form)
      )
        ? form
        : section.querySelector(
            'product-form form'
          );
    }

    function getQuantityInput() {
      var input =
        document.getElementById(
          'Quantity-' +
          sectionId
        );

      return (
        input &&
        section.contains(input)
      )
        ? input
        : section.querySelector(
            'input[name="quantity"]'
          );
    }

    function getQuantityBlock() {
      var input =
        getQuantityInput();

      return (
        section.querySelector(
          '.tiered-quantity-selector'
        ) ||
        (
          input &&
          input.closest(
            '.product-form__quantity, quantity-input'
          )
        )
      );
    }

    function quantity() {
      var active =
        section.querySelector(
          '.tiered-quantity-options ' +
          '.tiered-option--active' +
          '[data-quantity]'
        );

      var input =
        getQuantityInput();

      var value =
        active
          ? Number(
              active.dataset
                .quantity
            )
          : Number(
              input &&
              input.value
            );

      return (
        Number.isFinite(value) &&
        value > 0
      )
        ? Math.max(
            1,
            Math.min(
              3,
              Math.round(
                value
              )
            )
          )
        : 1;
    }

    /*
     * ===========================================
     * VARIANTES
     * ===========================================
     */

    function currentNativeVariant() {
      var form =
        getProductForm();

      var input =
        form &&
        form.querySelector(
          'input[name="id"]'
        );

      return (
        variants.find(
          function (
            variant
          ) {
            return (
              input &&
              Number(
                variant.id
              ) ===
              Number(
                input.value
              )
            );
          }
        ) ||

        variants.find(
          function (
            variant
          ) {
            return (
              variant.available !==
              false
            );
          }
        ) ||

        variants[0]
      );
    }

    function initialState() {
      var variant =
        currentNativeVariant();

      return {
        finish:
          variant.options[
            finishIndex
          ],

        scent:
          variant.options[
            scentIndex
          ]
      };
    }

    function ensureStates(
      count
    ) {
      if (
        !states.length
      ) {
        states.push(
          initialState()
        );
      }

      while (
        states.length <
        count
      ) {
        states.push({
          finish:
            states[0].finish,

          scent:
            states[0].scent
        });
      }

      activeIndex =
        Math.max(
          0,
          Math.min(
            activeIndex,
            count - 1
          )
        );
    }

    function variantFor(
      state
    ) {
      return (
        variants.find(
          function (
            variant
          ) {
            return (
              variant.available !==
                false &&

              variant.options &&

              variant.options[
                finishIndex
              ] ===
                state.finish &&

              variant.options[
                scentIndex
              ] ===
                state.scent
            );
          }
        ) ||
        null
      );
    }

    /*
     * ===========================================
     * PRIX DU BUNDLE
     * ===========================================
     */

    /* OLUNA V3 — remplace de function money(...) jusqu'AVANT function updateBundlePrices().
       Garde updateBundlePrices et toute la suite. Utiliser avec le selecteur V3.
       Les valeurs de variantes sont celles du marche courant (Shopify Markets).
       Aucune conversion de change n'est realisee par ce code.
    */
    function olunaPricingContainer() {
      return section.querySelector('.tiered-quantity-options[data-oluna-pricing-version="3"]');
    }

    function money(cents) {
      var container = olunaPricingContainer();
      var currency = container && container.getAttribute('data-oluna-currency');
      var locale = (container && container.getAttribute('data-oluna-locale')) ||
        document.documentElement.lang || 'fr';
      var amount = Number(cents);
      if (!Number.isFinite(amount)) return '';
      try {
        return new Intl.NumberFormat(locale.replace(/_/g, '-'), {
          style: 'currency', currency: currency
        }).format(amount / 100);
      } catch (_) {
        return (amount / 100).toFixed(2) + (currency ? ' ' + currency : '');
      }
    }

    function setText(node, value) {
      if (node && node.textContent !== value) node.textContent = value;
    }

    function olunaSetAttribute(node, name, value) {
      value = String(value);
      if (node && node.getAttribute(name) !== value) node.setAttribute(name, value);
    }

    function olunaSetHidden(node, hidden) {
      if (node && node.hidden !== hidden) node.hidden = hidden;
    }

    function olunaPercent(value) {
      var container = olunaPricingContainer();
      var locale = (container && container.getAttribute('data-oluna-locale')) ||
        document.documentElement.lang || 'fr';
      try {
        return new Intl.NumberFormat(locale.replace(/_/g, '-'), {
          maximumFractionDigits: 2
        }).format(value) + ' %';
      } catch (_) {
        return String(Math.round(value * 100) / 100) + ' %';
      }
    }

    /*
     * OLUNA — REGLES DYNAMIQUES DE COFFRET
     * --------------------------------------
     * Solo : aucun rabais.
     * Duo  : 10 % de remise sur la somme REELLE des 2 variantes.
     * Trio : la variante la moins chere des 3 est offerte.
     *
     * Cette logique calcule uniquement les montants affiches dans le theme.
     * La reduction doit aussi exister dans Shopify au panier/checkout.
     */
    function olunaDiscountRule(count) {
      count = Number(count);

      if (count === 1) {
        return { type: 'percentage', value: 0 };
      }

      if (count === 2) {
        return { type: 'percentage', value: 10 };
      }

      if (count === 3) {
        return { type: 'free_item', value: 1 };
      }

      return null;
    }

    function bundlePrice(count) {
      count = Number(count);
      if (!Number.isInteger(count) || count < 1 || count > 3 || !states.length) return null;
      var rule = olunaDiscountRule(count);
      if (!rule) return null;
      var subtotal = 0, originalSubtotal = 0, lowestPrice = Infinity;
      for (var index = 0; index < count; index += 1) {
        var variant = variantFor(states[index] || states[0]);
        if (!variant || variant.available === false || variant.price == null) return null;
        var price = Number(variant.price);
        if (!Number.isFinite(price) || price < 0) return null;
        price = Math.round(price);
        subtotal += price;
        lowestPrice = Math.min(lowestPrice, price);
        var original = Number(variant.compare_at_price);
        originalSubtotal += Number.isFinite(original) && original > price ? Math.round(original) : price;
      }
      var total;
      if (rule.type === 'free_item') {
        // Une seule gratuite dans le Trio : la moins chere si les variantes different.
        total = subtotal - lowestPrice;
      } else if (rule.type === 'fixed') {
        total = Math.max(0, subtotal - rule.value);
      } else {
        total = Math.round(subtotal * (100 - rule.value) / 100);
      }
      var discount = subtotal - total;
      return {
        subtotal: subtotal, originalSubtotal: originalSubtotal,
        total: total, discount: discount,
        perUnit: Math.round(total / count),
        percent: subtotal > 0 ? discount * 100 / subtotal : 0
      };
    }

    function olunaUpdatePriceTokens(scope, pricing) {
      scope.querySelectorAll('[data-oluna-price-value]').forEach(function (node) {
        var key = node.getAttribute('data-oluna-price-value');
        if (key === 'savings') setText(node, money(pricing.discount));
        if (key === 'unit') setText(node, money(pricing.perUnit));
        if (key === 'percent') setText(node, olunaPercent(pricing.percent));
      });
    }

    function updateTierPrice(button) {
      var count = Number(button.dataset.quantity);
      var pricing = bundlePrice(count);
      if (!pricing) return;
      setText(button.querySelector('.tiered-option__final-price'), money(pricing.total));
      var compareNodes = Array.from(button.querySelectorAll('.tiered-option__compare-price'));
      var compareTotal = button.getAttribute('data-oluna-compare-style') === 'original'
        ? pricing.originalSubtotal : pricing.subtotal;
      compareNodes.forEach(function (node, index) {
        if (index === 0) setText(node, money(compareTotal));
        olunaSetHidden(node, index > 0 || compareTotal <= pricing.total);
      });
      // Les spans preserves conservent le texte saisi et sa mise en forme.
      olunaUpdatePriceTokens(button.closest('.tiered-option-wrapper') || button, pricing);
      olunaSetAttribute(button, 'data-oluna-bundle-subtotal', pricing.subtotal);
      olunaSetAttribute(button, 'data-oluna-bundle-total', pricing.total);
      olunaSetAttribute(button, 'data-oluna-bundle-saving', pricing.discount);
    }

    function olunaUpdateMainSaleBadges(wrapper, pricing) {
      // Cible uniquement le badge de remise standard ; jamais les badges de stock.
      wrapper.querySelectorAll('.price__badge-sale, [data-oluna-sale-badge]').forEach(function (badge) {
        olunaSetHidden(badge, pricing.discount <= 0);
        if (pricing.discount <= 0) return;
        var valueNode = badge.querySelector('[data-oluna-sale-value]');
        if (!valueNode) {
          // Garde les icones SVG, remplace l'ancienne valeur calculee pour le produit seul.
          var icons = Array.from(badge.querySelectorAll('svg')).map(function (svg) {
            return svg.cloneNode(true);
          });
          valueNode = document.createElement('span');
          valueNode.setAttribute('data-oluna-sale-value', '');
          badge.replaceChildren.apply(badge, icons.concat([valueNode]));
        }
        setText(valueNode, '\u2212' + money(pricing.discount));
      });
    }

    function updateMainProductPrice() {
      var pricing = bundlePrice(quantity());
      if (!pricing) return;
      var wrapper = document.getElementById('price-' + sectionId);
      if (!wrapper || !section.contains(wrapper)) return;
      var priceRoot = wrapper.querySelector('.price') || wrapper;
      var regular = wrapper.querySelector(
        '.price__regular .price-item--regular, .up-product-price__regular .up-product-price__current'
      );
      var sale = wrapper.querySelector(
        '.price__sale .price-item--sale.price-item--last, .up-product-price__sale .up-product-price__current--sale'
      );
      var compare = wrapper.querySelector(
        '.price__sale .price-item--regular, .up-product-price__compare'
      );
      var onSale = pricing.discount > 0;
      if (priceRoot.classList && priceRoot.classList.contains('price--on-sale') !== onSale) {
        priceRoot.classList.toggle('price--on-sale', onSale);
      }
      setText(regular, money(pricing.total));
      setText(sale, money(pricing.total));
      if (compare) {
        setText(compare, money(pricing.subtotal));
        olunaSetHidden(compare, !onSale);
      }
      olunaUpdateMainSaleBadges(wrapper, pricing);
    }
    
    function updateBundlePrices() {
      section
        .querySelectorAll(
          '.tiered-quantity-options ' +
          '.tiered-option[data-quantity]'
        )
        .forEach(
          updateTierPrice
        );

      updateMainProductPrice();

      var form =
        getProductForm();

      var pricing =
        bundlePrice(
          quantity()
        );

      if (
        form &&
        pricing
      ) {
        form.dataset
          .olunaBundleSubtotalCents =
            String(
              pricing.subtotal
            );

        form.dataset
          .olunaBundleTotalCents =
            String(
              pricing.total
            );

        form.dataset
          .olunaBundleDiscountCents =
            String(
              pricing.discount
            );
      }
    }

    function queueBundlePriceRefresh() {
      priceRefreshTimers
        .forEach(
          clearTimeout
        );

      priceRefreshTimers =
        [];

      [
        0,
        100,
        300,
        700
      ].forEach(
        function (
          delay
        ) {
          priceRefreshTimers.push(
            setTimeout(
              function () {
                if (
                  !destroyed &&
                  root.isConnected
                ) {
                  updateBundlePrices();
                }
              },
              delay
            )
          );
        }
      );
    }

    /*
     * ===========================================
     * STRUCTURE
     * ===========================================
     */

    function removeLegacyCustomizer() {
      section
        .querySelectorAll(
          '.oluna-personalizer, ' +
          '[data-oluna-personalizer], ' +
          '.oluna-coffret-heading'
        )
        .forEach(
          function (
            node
          ) {
            if (
              node !== root &&
              !node.contains(
                root
              )
            ) {
              node.remove();
            }
          }
        );
    }

    function getPicker() {
      return section.querySelector(
        'variant-selects, variant-radios'
      );
    }

    function hideNativePicker() {
      var picker =
        getPicker();

      if (picker) {
        picker
          .classList
          .add(
            'oluna-native-picker--hidden'
          );

        picker.dataset
          .olunaOwner =
            sectionId;
      }
    }

    function ensurePosition() {
      var block =
        getQuantityBlock();

      if (
        !block ||
        !block.parentNode ||
        root.contains(
          block
        )
      ) {
        return;
      }

      var parent =
        block.parentNode;

      if (
        !heading ||
        !heading.isConnected
      ) {
        heading =
          document.createElement(
            'div'
          );

        heading.id =
          'OlunaCoffretHeading-' +
          sectionId;

        heading.className =
          'oluna-coffret-heading-' +
          sectionId;

        heading.dataset
          .olunaCoffretHeading =
            sectionId;

        heading.innerHTML =
          '<span>1.</span>' +
          '<span>Choisissez votre coffret</span>';
      }

      heading.hidden =
        false;

      if (
        heading.parentNode !==
          parent ||
        heading.nextElementSibling !==
          block
      ) {
        parent.insertBefore(
          heading,
          block
        );
      }

      if (
        root.parentNode !==
          parent ||
        block.nextElementSibling !==
          root
      ) {
        parent.insertBefore(
          root,
          block.nextSibling
        );
      }
    }

    /*
     * ===========================================
     * APPARENCE OPTIONS
     * ===========================================
     */

    function swatchClass(
      value
    ) {
      var name =
        normalize(
          value
        );

      if (
        name.includes(
          'noir'
        ) ||
        name.includes(
          'black'
        )
      ) {
        return (
          'oluna-bundle-swatch--black'
        );
      }

      if (
        name === 'or' ||
        name.includes(
          'gold'
        ) ||
        name.includes(
          'champagne'
        )
      ) {
        return (
          'oluna-bundle-swatch--gold'
        );
      }

      if (
        name.includes(
          'argent'
        ) ||
        name.includes(
          'silver'
        )
      ) {
        return (
          'oluna-bundle-swatch--silver'
        );
      }

      return '';
    }

    function scentDescription(
      value
    ) {
      var name =
        normalize(
          value
        );

      if (
        name.includes(
          'sans odeur'
        ) ||
        name.includes(
          'neutre'
        )
      ) {
        return (
          'Pure et discrète'
        );
      }

      if (
        name.includes(
          'the blanc'
        ) ||
        name.includes(
          'white tea'
        )
      ) {
        return (
          'Frais et délicat'
        );
      }

      if (
        name.includes(
          'santal'
        ) ||
        name.includes(
          'sandalwood'
        )
      ) {
        return (
          'Boisé et enveloppant'
        );
      }

      return '';
    }

    function scentIcon(
      value
    ) {
      var name =
        normalize(
          value
        );

      if (
        name.includes(
          'the blanc'
        ) ||
        name.includes(
          'white tea'
        )
      ) {
        return (
          '<svg viewBox="0 0 48 48" aria-hidden="true">' +
            '<g fill="none" stroke="currentColor" stroke-width="1.4">' +
              '<ellipse cx="24" cy="13" rx="5.5" ry="9"></ellipse>' +
              '<ellipse cx="24" cy="35" rx="5.5" ry="9"></ellipse>' +
              '<ellipse cx="13" cy="24" rx="9" ry="5.5"></ellipse>' +
              '<ellipse cx="35" cy="24" rx="9" ry="5.5"></ellipse>' +
              '<ellipse cx="16.5" cy="16.5" rx="5" ry="8" transform="rotate(-45 16.5 16.5)"></ellipse>' +
              '<ellipse cx="31.5" cy="31.5" rx="5" ry="8" transform="rotate(-45 31.5 31.5)"></ellipse>' +
            '</g>' +
            '<circle cx="24" cy="24" r="4" fill="#C4A35A"></circle>' +
          '</svg>'
        );
      }

      if (
        name.includes(
          'santal'
        ) ||
        name.includes(
          'sandalwood'
        )
      ) {
        return (
          '<svg viewBox="0 0 48 48" aria-hidden="true">' +
            '<g fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round">' +
              '<path d="M11 31 L32 13"></path>' +
              '<path d="M15 36 L37 17"></path>' +
              '<path d="M10 20 L30 39"></path>' +
              '<path d="M16 13 L39 33"></path>' +
            '</g>' +
            '<circle cx="15" cy="34" r="5" fill="none" stroke="currentColor" stroke-width="1.5"></circle>' +
            '<circle cx="35" cy="15" r="5" fill="none" stroke="currentColor" stroke-width="1.5"></circle>' +
          '</svg>'
        );
      }

      return (
        '<span class="oluna-bundle-scent-neutral"></span>'
      );
    }

    function choice(
      type,
      value,
      selected,
      index
    ) {
      var button =
        document.createElement(
          'button'
        );

      button.type =
        'button';

      button.className =
        'oluna-bundle-choice' +
        (
          selected
            ? ' is-selected'
            : ''
        );

      button.dataset
        .bundleType =
          type;

      button.dataset
        .bundleValue =
          value;

      button.dataset
        .bundleIndex =
          String(
            index
          );

      button.setAttribute(
        'aria-pressed',
        selected
          ? 'true'
          : 'false'
      );

      if (
        type ===
        'finish'
      ) {
        var swatch =
          document.createElement(
            'span'
          );

        swatch.className =
          'oluna-bundle-swatch ' +
          swatchClass(
            value
          );

        swatch.setAttribute(
          'aria-hidden',
          'true'
        );

        button.appendChild(
          swatch
        );
      } else {
        button.classList.add(
          'oluna-bundle-choice--scent'
        );

        var icon =
          document.createElement(
            'span'
          );

        icon.className =
          'oluna-bundle-scent-icon';

        icon.setAttribute(
          'aria-hidden',
          'true'
        );

        icon.innerHTML =
          scentIcon(
            value
          );

        button.appendChild(
          icon
        );
      }

      var text =
        document.createElement(
          'span'
        );

      text.textContent =
        value;

      button.appendChild(
        text
      );

      if (
        type ===
        'scent'
      ) {
        var description =
          scentDescription(
            value
          );

        if (
          description
        ) {
          var tooltip =
            document.createElement(
              'small'
            );

          tooltip.className =
            'oluna-bundle-tooltip';

          tooltip.textContent =
            description;

          button.appendChild(
            tooltip
          );
        }
      }

      return button;
    }

    /*
     * ===========================================
     * SYNCHRONISATION VARIANTE + PHOTO
     * ===========================================
     */

    function syncNativePreview(state) {
  var variant = variantFor(state);
  var picker = getPicker();

  if (!variant) {
    return;
  }

  /*
   * La galerie est à gauche de product-info.
   * "section" vaut actuellement product-info,
   * donc on récupère aussi la vraie section Shopify complète.
   */
  var productSection =
    root.closest('.shopify-section') ||
    section;

  var trigger = null;
  var fallback = null;
  var nativeVariant = null;

  /*
   * ==========================================================
   * 1. RÉCUPÈRE LA VARIANTE NATIVE SHOPIFY
   * ==========================================================
   */

  if (picker) {
    var nativeDataNode =
      picker.querySelector(
        '[type="application/json"]'
      );

    if (nativeDataNode) {
      try {
        var nativeVariants =
          JSON.parse(
            nativeDataNode.textContent
          );

        if (
          Array.isArray(
            nativeVariants
          )
        ) {
          nativeVariant =
            nativeVariants.find(
              function (item) {
                return (
                  Number(item.id) ===
                  Number(variant.id)
                );
              }
            ) || null;
        }
      } catch (error) {
        console.warn(
          'OLUNA : données variantes Shopify illisibles.',
          error
        );
      }
    }
  }

  /*
   * ==========================================================
   * 2. SYNCHRONISE LE SÉLECTEUR NATIF CACHÉ
   * ==========================================================
   */

  if (picker) {
    var controls =
      Array.from(
        picker.querySelectorAll(
          'fieldset, select'
        )
      ).filter(
        function (element) {
          return (
            element.tagName === 'FIELDSET'
              ? !element.querySelector('select')
              : true
          );
        }
      );

    controls.forEach(
      function (control, position) {
        var expected =
          variant.options[position];

        if (
          expected === undefined
        ) {
          return;
        }

        /*
         * SELECT
         */
        if (
          control.tagName ===
          'SELECT'
        ) {
          var option =
            Array.from(
              control.options
            ).find(
              function (element) {
                return (
                  element.value === expected ||
                  element.text === expected
                );
              }
            );

          if (!option) {
            return;
          }

          fallback = control;

          if (
            control.value !==
            option.value
          ) {
            control.value =
              option.value;

            option.selected =
              true;

            if (!trigger) {
              trigger = control;
            }
          }
        }

        /*
         * RADIO
         */
        else {
          var input =
            Array.from(
              control.querySelectorAll(
                'input[type="radio"]'
              )
            ).find(
              function (element) {
                return (
                  element.value === expected
                );
              }
            );

          if (!input) {
            return;
          }

          fallback = input;

          if (!input.checked) {
            input.checked = true;

            if (!trigger) {
              trigger = input;
            }
          }
        }
      }
    );

    /*
     * Déclenche le vrai moteur de variantes Shopify.
     */
    var eventTarget =
      trigger ||
      fallback;

    if (eventTarget) {
      eventTarget.dispatchEvent(
        new Event(
          'change',
          {
            bubbles: true
          }
        )
      );
    }

    /*
     * Après le "change", VariantSelects a normalement
     * renseigné picker.currentVariant.
     *
     * C'est la source la plus fiable pour featured_media.
     */
    if (
      picker.currentVariant &&
      Number(
        picker.currentVariant.id
      ) ===
      Number(
        variant.id
      )
    ) {
      nativeVariant =
        picker.currentVariant;
    }
  }

  /*
   * ==========================================================
   * 3. SYNCHRONISE L'ID DE VARIANTE DU FORMULAIRE
   * ==========================================================
   */

  var form =
    getProductForm();

  var idInput =
    form &&
    form.querySelector(
      'input[name="id"]'
    );

  if (
    idInput &&
    Number(idInput.value) !==
      Number(variant.id)
  ) {
    idInput.value =
      variant.id;

    idInput.dispatchEvent(
      new Event(
        'change',
        {
          bubbles: true
        }
      )
    );
  }

  /*
   * ==========================================================
   * 4. TROUVE L'ID DU MÉDIA LIÉ À LA VARIANTE
   * ==========================================================
   */

  function getMediaId(value) {
    if (!value) {
      return null;
    }

    if (
      typeof value === 'number' ||
      typeof value === 'string'
    ) {
      var numeric =
        Number(value);

      return Number.isFinite(numeric)
        ? numeric
        : null;
    }

    if (value.id) {
      return Number(
        value.id
      );
    }

    return null;
  }

  var mediaId =
    getMediaId(
      nativeVariant &&
      nativeVariant.featured_media
    ) ||

    getMediaId(
      nativeVariant &&
      nativeVariant.featured_image
    ) ||

    getMediaId(
      variant.featured_media
    ) ||

    getMediaId(
      variant.featured_image
    );

  if (!mediaId) {
    console.warn(
      'OLUNA : aucune image n’est associée à la variante',
      variant.id,
      state
    );

    queueBundlePriceRefresh();

    return;
  }

  /*
   * ==========================================================
   * 5. IDENTIFIE EXACTEMENT LA GALERIE PRODUIT
   * ==========================================================
   */

  var mediaSectionId =
    (
      picker &&
      picker.dataset.section
    ) ||
    sectionId;

  var mediaKey =
    mediaSectionId +
    '-' +
    mediaId;

  var gallery =
    document.getElementById(
      'MediaGallery-' +
      mediaSectionId
    ) ||

    document.getElementById(
      'MediaGallery-' +
      sectionId
    ) ||

    (
      productSection &&
      productSection.querySelector(
        'media-gallery'
      )
    );

  if (!gallery) {
    console.warn(
      'OLUNA : galerie produit introuvable',
      mediaKey
    );

    queueBundlePriceRefresh();

    return;
  }

  /*
   * ==========================================================
   * 6. MÉTHODE NATIVE DE LA GALERIE
   * ==========================================================
   */

  function forceCorrectMedia() {
    if (
      destroyed ||
      !gallery.isConnected
    ) {
      return;
    }

    /*
     * Première méthode :
     * API MediaGallery native.
     */
    if (
      typeof gallery.setActiveMedia ===
      'function'
    ) {
      try {
        gallery.setActiveMedia(
          mediaKey,
          true
        );
      } catch (error) {
        console.warn(
          'OLUNA : setActiveMedia a échoué.',
          error
        );
      }
    }

    /*
     * ========================================================
     * 7. CLIQUE SUR LA VRAIE MINIATURE
     * ========================================================
     *
     * IMPORTANT :
     *
     * data-target est placé sur le <li>.
     * Le listener de galerie est attaché au <button> enfant.
     */

    var targetItem =
      Array.from(
        gallery.querySelectorAll(
          '[data-target]'
        )
      ).find(
        function (element) {
          return (
            element.dataset.target ===
            mediaKey
          );
        }
      );

    if (targetItem) {
      var thumbnailButton =
        targetItem.matches('button')
          ? targetItem
          : targetItem.querySelector(
              'button'
            );

      if (
        thumbnailButton &&
        typeof thumbnailButton.click ===
          'function'
      ) {
        thumbnailButton.click();
      }

      /*
       * Synchronise visuellement la miniature active.
       */
      gallery
        .querySelectorAll(
          '[data-target] button'
        )
        .forEach(
          function (button) {
            var item =
              button.closest(
                '[data-target]'
              );

            if (
              item &&
              item.dataset.target ===
                mediaKey
            ) {
              button.setAttribute(
                'aria-current',
                'true'
              );
            } else {
              button.removeAttribute(
                'aria-current'
              );
            }
          }
        );
    }

    /*
     * ========================================================
     * 8. FALLBACK DIRECT SUR LE SLIDE
     * ========================================================
     */

    var activeSlide =
      Array.from(
        gallery.querySelectorAll(
          '[data-media-id]'
        )
      ).find(
        function (slide) {
          return (
            slide.dataset.mediaId ===
            mediaKey
          );
        }
      );

    if (activeSlide) {
      gallery
        .querySelectorAll(
          '[data-media-id]'
        )
        .forEach(
          function (slide) {
            slide.classList.toggle(
              'is-active',
              slide === activeSlide
            );
          }
        );

      var slider =
        gallery.querySelector(
          '#Slider-Gallery-' +
          mediaSectionId
        ) ||

        gallery.querySelector(
          '.product__media-list'
        );

      if (
        slider &&
        typeof slider.scrollTo ===
          'function'
      ) {
        slider.scrollTo({
          left:
            activeSlide.offsetLeft,

          behavior:
            'auto'
        });
      }
    }
  }

  /*
   * Immédiat.
   */
  forceCorrectMedia();

  /*
   * Puis une deuxième fois après l'évènement
   * natif Shopify, au cas où celui-ci ait fini
   * son propre traitement juste après.
   */
  setTimeout(
    forceCorrectMedia,
    50
  );

  setTimeout(
    forceCorrectMedia,
    180
  );

  /*
   * ==========================================================
   * 9. SYNCHRONISE LA MODALE
   * ==========================================================
   */

  var modalContent =
    document.querySelector(
      '#ProductModal-' +
      mediaSectionId +
      ' ' +
      '.product-media-modal__content'
    );

  if (modalContent) {
    var modalMedia =
      Array.from(
        modalContent.querySelectorAll(
          '[data-media-id]'
        )
      ).find(
        function (element) {
          return (
            element.dataset.mediaId ===
              mediaKey ||
            element.dataset.mediaId ===
              String(mediaId)
          );
        }
      );

    if (modalMedia) {
      modalContent.prepend(
        modalMedia
      );
    }
  }

  /*
   * Le changement de variante remet temporairement
   * le prix individuel Shopify.
   *
   * On réapplique donc ensuite les prix du bundle.
   */
  queueBundlePriceRefresh();
}

    function setupFastCheckout(
      productForm,
      fastButton,
      count
    ) {
      if (
        !fastButton
      ) {
        return;
      }

      var cover =
        fastButton.querySelector(
          '.oluna-bundle-fast-checkout__cover'
        );

      if (
        count <= 1
      ) {
        fastButton
          .classList
          .remove(
            'oluna-bundle-fast-checkout'
          );

        if (
          cover
        ) {
          cover.remove();
        }

        return;
      }

      fastButton
        .classList
        .add(
          'oluna-bundle-fast-checkout'
        );

      if (
        !cover
      ) {
        cover =
          document.createElement(
            'button'
          );

        cover.type =
          'button';

        cover.className =
          'oluna-bundle-fast-checkout__cover';

        cover.setAttribute(
          'aria-label',
          'Acheter maintenant avec votre coffret personnalisé'
        );

        fastButton.appendChild(
          cover
        );
      }

      cover.onclick =
        async function (
          event
        ) {
          event.preventDefault();
          event.stopPropagation();

          if (
            cover.disabled ||
            destroyed
          ) {
            return;
          }

          if (
            !applyCartData()
          ) {
            return;
          }

          var items =
            (
              productForm &&
              typeof productForm
                .getOlunaBundleItems ===
                'function'
            )
              ? productForm
                  .getOlunaBundleItems()
              : null;

          if (
            !items ||
            items.length !==
              quantity()
          ) {
            errorNode.textContent =
              'Votre coffret n’est pas encore prêt. Vérifiez vos choix.';

            errorNode.hidden =
              false;

            return;
          }

          cover.disabled =
            true;

          try {
            var config =
              typeof productForm
                .getOlunaBundleConfig ===
                'function'
                ? productForm
                    .getOlunaBundleConfig(
                      items
                    )
                : null;

            if (
              !config
            ) {
              throw new Error(
                'Configuration du coffret indisponible.'
              );
            }

            var cartAddUrl =
              root.dataset
                .cartAddUrl ||

              (
                window.routes &&
                window.routes
                  .cart_add_url
              ) ||

              (
                (
                  window.Shopify &&
                  window.Shopify
                    .routes &&
                  window.Shopify
                    .routes.root
                ) ||
                '/'
              ) +
              'cart/add.js';

            var response =
              await fetch(
                cartAddUrl,
                config
              );

            var body =
              await response
                .json();

            if (
              !response.ok ||
              body.status
            ) {
              throw new Error(
                body.description ||
                body.message ||
                'Impossible d’ajouter le coffret.'
              );
            }

            window.location.href =
              root.dataset
                .checkoutUrl ||
              '/checkout';

          } catch (
            error
          ) {
            console.error(
              'OLUNA : paiement du coffret.',
              error
            );

            errorNode.textContent =
              (
                error &&
                error.message
              )
                ? error.message
                : 'Impossible de poursuivre vers le paiement.';

            errorNode.hidden =
              false;

            cover.disabled =
              false;
          }
        };
    }

    /*
     * ===========================================
     * DONNÉES PANIER
     * ===========================================
     */

    function applyCartData() {
      if (
        destroyed ||
        !root.isConnected
      ) {
        return false;
      }

      var count =
        quantity();

      ensureStates(
        count
      );

      var form =
        getProductForm();

      if (
        !form
      ) {
        return false;
      }

      var items = [];
      var invalid = [];

      states
        .slice(
          0,
          count
        )
        .forEach(
          function (
            state,
            index
          ) {
            var variant =
              variantFor(
                state
              );

            if (
              !variant
            ) {
              invalid.push(
                index + 1
              );
            } else {
              items.push({
                id:
                  Number(
                    variant.id
                  ),

                slot:
                  index + 1,

                finish:
                  state.finish,

                scent:
                  state.scent
              });
            }
          }
        );

      var valid =
        invalid.length === 0 &&
        items.length ===
          count;

      if (
        !valid
      ) {
        delete form
          .dataset
          .olunaBundleItems;

        form.dataset
          .olunaBundleInvalid =
            'true';

        errorNode.textContent =
          'Combinaison indisponible pour ' +
          (
            invalid.length >
            1
              ? 'les bougies '
              : 'la bougie '
          ) +
          invalid.join(', ') +
          '. Modifiez vos choix.';

        errorNode.hidden =
          false;
      } else {
        delete form
          .dataset
          .olunaBundleInvalid;

        errorNode.hidden =
          true;

        errorNode.textContent =
          '';

        if (
          count > 1
        ) {
          form.dataset
            .olunaBundleItems =
              JSON.stringify(
                items
              );
        } else {
          delete form
            .dataset
            .olunaBundleItems;
        }
      }

      var productForm =
        form.closest(
          'product-form'
        );

      var fastButton =
        productForm &&
        productForm.querySelector(
          '.shopify-payment-button'
        );

      if (
        fastButton
      ) {
        if (
          valid
        ) {
          delete fastButton
            .dataset
            .olunaBundleUnavailable;
        } else {
          fastButton.dataset
            .olunaBundleUnavailable =
              'true';
        }

        setupFastCheckout(
          productForm,
          fastButton,
          count
        );
      }

      return valid;
    }

    /*
     * ===========================================
     * AFFICHAGE D'UNE BOUGIE
     * ===========================================
     */

    function renderCard(
      count
    ) {
      var state =
        states[
          activeIndex
        ];

      var card =
        document.createElement(
          'div'
        );

      card.className =
        'oluna-bundle-item';

      card.dataset
        .olunaCandle =
          String(
            activeIndex +
            1
          );

      var top =
        document.createElement(
          'div'
        );

      top.className =
        'oluna-bundle-item__top';

      var name =
        document.createElement(
          'span'
        );

      name.className =
        'oluna-bundle-item__name';

      name.textContent =
        count === 1
          ? 'Votre bougie'
          : 'Bougie ' +
            (
              activeIndex +
              1
            );

      var summary =
        document.createElement(
          'span'
        );

      summary.className =
        'oluna-bundle-item__summary';

      summary.textContent =
        state.finish +
        ' · ' +
        state.scent;

      top.append(
        name,
        summary
      );

      card.appendChild(
        top
      );

      [
        'finish',
        'scent'
      ].forEach(
        function (
          type
        ) {
          var label =
            type ===
            'finish'
              ? 'Finition'
              : 'Senteur';

          var group =
            document.createElement(
              'div'
            );

          group.className =
            'oluna-bundle-item__section';

          group.setAttribute(
            'role',
            'group'
          );

          group.setAttribute(
            'aria-label',
            label +
            ' de la bougie ' +
            (
              activeIndex +
              1
            )
          );

          var text =
            document.createElement(
              'span'
            );

          text.className =
            'oluna-bundle-item__label';

          text.textContent =
            label;

          group.appendChild(
            text
          );

          var row =
            document.createElement(
              'div'
            );

          row.className =
            'oluna-bundle-choice-row';

          var values =
            type ===
            'finish'
              ? finishValues
              : scentValues;

          values.forEach(
            function (
              value
            ) {
              row.appendChild(
                choice(
                  type,
                  value,
                  state[type] ===
                    value,
                  activeIndex
                )
              );
            }
          );

          group.appendChild(
            row
          );

          card.appendChild(
            group
          );
        }
      );

      itemsNode.replaceChildren(
        card
      );
    }

    /*
     * ===========================================
     * RENDER PRINCIPAL
     * ===========================================
     */

    function render() {
      if (
        destroyed ||
        !root.isConnected
      ) {
        return;
      }

      var count =
        quantity();

      var quantityChanged =
        lastQuantity !==
          0 &&
        count !==
          lastQuantity;

      ensureStates(
        count
      );

      removeLegacyCustomizer();

      ensurePosition();

      hideNativePicker();

      root.hidden =
        false;

      root.dataset
        .initialized =
          'true';

      root.dataset
        .activeCandle =
          String(
            activeIndex +
            1
          );

      titleNode.textContent =
        count === 1
          ? 'Personnalisez votre bougie'

          : count === 2
            ? 'Personnalisez votre Duo OLUNA'

            : 'Personnalisez votre Trio OLUNA';

      introNode.textContent =
        count === 1
          ? 'Choisissez la finition et la senteur de votre bougie.'

          : 'Choisissez la finition et la senteur de chaque bougie à l’aide des flèches.';

      nav.hidden =
        count === 1;

      previous.hidden =
        activeIndex ===
        0;

      previous.disabled =
        previous.hidden;

      next.hidden =
        activeIndex >=
        count - 1;

      next.disabled =
        next.hidden;

      var previousLabel =
        'Bougie ' +
        activeIndex;

      var nextLabel =
        'Bougie ' +
        (
          activeIndex +
          2
        );

      previous
        .querySelector(
          '[data-oluna-bundle-prev-label]'
        )
        .textContent =
          previous.hidden
            ? 'Bougie 1'
            : previousLabel;

      next
        .querySelector(
          '[data-oluna-bundle-next-label]'
        )
        .textContent =
          next.hidden
            ? 'Bougie ' +
              count
            : nextLabel;

      var currentLabel =
        'Bougie ' +
        (
          activeIndex +
          1
        ) +
        ' / ' +
        count;

      current.textContent =
        currentLabel;

      /*
       * Affiche uniquement
       * la bougie active.
       */
      renderCard(
        count
      );

      /*
       * Enregistre toutes
       * les variantes du bundle.
       */
      applyCartData();

      /*
       * Prix :
       * somme individuelle
       * puis remise.
       */
      updateBundlePrices();

      lastQuantity =
        count;

      /*
       * Si Solo → Duo → Trio,
       * synchronise également
       * l'aperçu de la bougie active.
       */
      if (
        quantityChanged
      ) {
        syncNativePreview(
          states[
            activeIndex
          ]
        );
      }
    }

    function scheduleRender(
      delay
    ) {
      clearTimeout(
        renderTimer
      );

      renderTimer =
        setTimeout(
          render,
          delay ===
            undefined
            ? 40
            : delay
        );
    }

    /*
     * ===========================================
     * NAVIGATION ENTRE LES BOUGIES
     * ===========================================
     */

    function moveTo(
      index
    ) {
      var count =
        quantity();

      if (
        index < 0 ||
        index >= count
      ) {
        return;
      }

      activeIndex =
        index;

      render();

      /*
       * Affiche la photo de
       * la bougie sélectionnée.
       */
      syncNativePreview(
        states[
          activeIndex
        ]
      );
    }

    /*
     * ===========================================
     * CLICS PERSONNALISATEUR
     * ===========================================
     */

    function onRootClick(
      event
    ) {
      var button =
        event.target.closest(
          'button'
        );

      if (
        !button ||
        !root.contains(
          button
        )
      ) {
        return;
      }

      /*
       * Flèche précédente /
       * suivante.
       */
      if (
        button === previous ||
        button === next
      ) {
        event.preventDefault();

        moveTo(
          activeIndex +
          (
            button === next
              ? 1
              : -1
          )
        );

        return;
      }

      if (
        !button.hasAttribute(
          'data-bundle-type'
        )
      ) {
        return;
      }

      event.preventDefault();

      var index =
        Number(
          button.dataset
            .bundleIndex
        );

      var type =
        button.dataset
          .bundleType;

      var value =
        button.dataset
          .bundleValue;

      if (
        index !==
          activeIndex ||

        !states[index] ||

        (
          type !==
            'finish' &&
          type !==
            'scent'
        )
      ) {
        return;
      }

      /*
       * Change uniquement
       * cette bougie.
       */
      states[index][type] =
        value;

      /*
       * Recalcule :
       * - affichage
       * - panier
       * - prix du bundle
       */
      render();

      /*
       * Puis synchronise
       * Shopify et sa photo.
       */
      syncNativePreview(
        states[index]
      );

      /*
       * Replace le focus
       * sur le bouton recréé.
       */
      var restored =
        Array.from(
          root.querySelectorAll(
            '[data-bundle-type]'
          )
        ).find(
          function (
            element
          ) {
            return (
              element.dataset
                .bundleType ===
                  type &&

              element.dataset
                .bundleValue ===
                  value
            );
          }
        );

      if (
        restored
      ) {
        restored.focus({
          preventScroll:
            true
        });
      }
    }

    /*
     * ===========================================
     * SÉLECTEUR SOLO / DUO / TRIO
     * ===========================================
     */

    function onSectionClick(
      event
    ) {
      var option =
        event.target.closest(
          '.tiered-quantity-options ' +
          '.tiered-option'
        );

      if (
        option &&
        section.contains(
          option
        )
      ) {
        scheduleRender(
          40
        );

        queueBundlePriceRefresh();
      }
    }

    function onSectionChange(
      event
    ) {
      if (
        event.target ===
        getQuantityInput()
      ) {
        scheduleRender(
          30
        );

        queueBundlePriceRefresh();
      }
    }

    /*
     * ===========================================
     * SUBMIT
     * ===========================================
     */

    function onSubmit(
      event
    ) {
      if (
        event.target !==
        getProductForm()
      ) {
        return;
      }

      if (
        !applyCartData()
      ) {
        event.preventDefault();

        event
          .stopImmediatePropagation();
      }
    }

    /*
     * ===========================================
     * CLAVIER
     * ===========================================
     */

    function onKeydown(
      event
    ) {
      if (
        !nav.contains(
          event.target
        ) ||
        quantity() ===
          1
      ) {
        return;
      }

      if (
        event.key !==
          'ArrowLeft' &&

        event.key !==
          'ArrowRight'
      ) {
        return;
      }

      event.preventDefault();

      moveTo(
        activeIndex +
        (
          event.key ===
          'ArrowRight'
            ? 1
            : -1
        )
      );
    }

    root.addEventListener(
      'click',
      onRootClick
    );

    root.addEventListener(
      'keydown',
      onKeydown
    );

    section.addEventListener(
      'click',
      onSectionClick
    );

    section.addEventListener(
      'change',
      onSectionChange
    );

    section.addEventListener(
      'submit',
      onSubmit,
      true
    );

    /*
     * ===========================================
     * OBSERVER HERITAGE
     * ===========================================
     *
     * Heritage recharge les prix
     * et certaines parties de la
     * fiche après changement
     * de variante.
     */

    if (
      'MutationObserver'
      in window
    ) {
      observer =
        new MutationObserver(
          function (
            records
          ) {
            var refresh =
              records.some(
                function (
                  record
                ) {
                  /*
                   * Ignore les mutations
                   * du personnalisateur.
                   */
                  if (
                    root.contains(
                      record.target
                    )
                  ) {
                    return false;
                  }

                  /*
                   * Changement du pack actif.
                   */
                  if (
                    record.type ===
                      'attributes' &&

                    record.target
                      .matches
                  ) {
                    return (
                      record.target.matches(
                        '.tiered-option, ' +
                        'input[name="quantity"]'
                      )
                    );
                  }

                  /*
                   * Heritage remplace
                   * le contenu des offres.
                   */
                  if (
                    record.target
                      .closest &&

                    record.target
                      .closest(
                        '.tiered-quantity-selector'
                      )
                  ) {
                    return true;
                  }

                  /*
                   * Shopify recharge
                   * le prix principal.
                   */
                  var mainPrice =
                    document
                      .getElementById(
                        'price-' +
                        sectionId
                      );

                  if (
                    mainPrice &&
                    (
                      record.target ===
                        mainPrice ||

                      mainPrice.contains(
                        record.target
                      )
                    )
                  ) {
                    return true;
                  }

                  /*
                   * Éléments injectés.
                   */
                  return Array.from(
                    record.addedNodes ||
                    []
                  ).some(
                    function (
                      node
                    ) {
                      if (
                        node.nodeType !==
                          1 ||

                        root.contains(
                          node
                        )
                      ) {
                        return false;
                      }

                      var selector =
                        'form, ' +
                        '.tiered-quantity-selector, ' +
                        'quantity-input, ' +
                        '.shopify-payment-button, ' +
                        'variant-selects, ' +
                        'variant-radios';

                      return (
                        node.matches(
                          selector
                        ) ||

                        node.querySelector(
                          selector
                        )
                      );
                    }
                  );
                }
              );

            if (
              refresh
            ) {
              scheduleRender();
            }
          }
        );

      observer.observe(
        section,
        {
          childList:
            true,

          subtree:
            true,

          attributes:
            true,

          attributeFilter: [
            'class',
            'value',
            'data-quantity'
          ]
        }
      );
    }

    /*
     * ===========================================
     * PREMIER RENDU
     * ===========================================
     */

    render();

    queueBundlePriceRefresh();

    /*
     * Le formulaire peut être
     * injecté légèrement après.
     */

    function retryMissingForm() {
      if (
        destroyed ||
        !root.isConnected ||
        getProductForm() ||
        retries++ >= 10
      ) {
        return;
      }

      retryTimer =
        setTimeout(
          function () {
            render();

            retryMissingForm();
          },
          150
        );
    }

    retryMissingForm();

    /*
     * ===========================================
     * DESTROY
     * ===========================================
     */

    return {
      render:
        render,

      destroy:
        function () {
          destroyed =
            true;

          clearTimeout(
            renderTimer
          );

          clearTimeout(
            retryTimer
          );

          priceRefreshTimers
            .forEach(
              clearTimeout
            );

          priceRefreshTimers =
            [];

          if (
            observer
          ) {
            observer.disconnect();
          }

          root.removeEventListener(
            'click',
            onRootClick
          );

          root.removeEventListener(
            'keydown',
            onKeydown
          );

          section.removeEventListener(
            'click',
            onSectionClick
          );

          section.removeEventListener(
            'change',
            onSectionChange
          );

          section.removeEventListener(
            'submit',
            onSubmit,
            true
          );

          var picker =
            getPicker();

          if (
            picker &&
            picker.dataset
              .olunaOwner ===
              sectionId
          ) {
            picker.classList.remove(
              'oluna-native-picker--hidden'
            );

            delete picker.dataset
              .olunaOwner;
          }

          var form =
            getProductForm();

          if (
            form
          ) {
            delete form.dataset
              .olunaBundleItems;

            delete form.dataset
              .olunaBundleInvalid;

            delete form.dataset
              .olunaBundleSubtotalCents;

            delete form.dataset
              .olunaBundleTotalCents;

            delete form.dataset
              .olunaBundleDiscountCents;

            var productForm =
              form.closest(
                'product-form'
              );

            var fastButton =
              productForm &&
              productForm
                .querySelector(
                  '.shopify-payment-button'
                );

            if (
              fastButton
            ) {
              delete fastButton
                .dataset
                .olunaBundleUnavailable;

              fastButton
                .classList
                .remove(
                  'oluna-bundle-fast-checkout'
                );

              var cover =
                fastButton
                  .querySelector(
                    '.oluna-bundle-fast-checkout__cover'
                  );

              if (
                cover
              ) {
                cover.remove();
              }
            }
          }

          root.hidden =
            true;

          if (
            heading
          ) {
            heading.hidden =
              true;
          }

          delete root.dataset
            .initialized;
        }
    };
  }

  /*
   * ===========================================
   * INIT
   * ===========================================
   */

  function init(
    scope
  ) {
    instances.forEach(
      function (
        controller,
        root
      ) {
        if (
          !root.isConnected
        ) {
          controller.destroy();

          instances.delete(
            root
          );
        }
      }
    );

    var roots = [];

    if (
      scope.matches &&
      scope.matches(
        '[data-oluna-bundle-customizer]'
      )
    ) {
      roots.push(
        scope
      );
    }

    if (
      scope.querySelectorAll
    ) {
      roots =
        roots.concat(
          Array.from(
            scope.querySelectorAll(
              '[data-oluna-bundle-customizer]'
            )
          )
        );
    }

    roots.forEach(
      function (
        root
      ) {
        if (
          instances.has(
            root
          )
        ) {
          return;
        }

        var controller =
          createCustomizer(
            root
          );

        if (
          controller
        ) {
          instances.set(
            root,
            controller
          );
        }
      }
    );
  }

  /*
   * V7 :
   * évite de réutiliser
   * les anciennes V3/V4/V5/V6.
   */

  window.OlunaBundleCustomizerV7 = {
    init:
      init
  };

  document.addEventListener(
    'shopify:section:load',
    function (
      event
    ) {
      init(
        event.target
      );
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    function (
      event
    ) {
      instances.forEach(
        function (
          controller,
          root
        ) {
          if (
            event.target ===
              root ||

            event.target.contains(
              root
            )
          ) {
            controller.destroy();

            instances.delete(
              root
            );
          }
        }
      );
    }
  );

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        init(
          document
        );
      },
      {
        once:
          true
      }
    );
  } else {
    init(
      document
    );
  }
})();
  } catch(e) { console.error(e); }
})();

})();
